import { render, staticRenderFns } from "./ProjectNotificationCompanySettings.vue?vue&type=template&id=373bee47&"
import script from "./ProjectNotificationCompanySettings.vue?vue&type=script&lang=js&"
export * from "./ProjectNotificationCompanySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports